import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export const publishDisplayCreatedCaseToasterEvent = (data: any) => {
  /* publish event for displaying a toaster message when new case is created */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.DISPLAY_CASE_CREATED_TOASTER, data);
};
export const publishCreateStageDoneEvent = (data: any) => {
  /* publish create stage info to infinity for case tracking */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.CASE_EVENTS.CREATE_STAGE_DONE, data);
};

export const publishCaseViewOpenedAfterCreateEvent = (data: Record<string, string>) => {
  /* publish event to notify that a case view has been opened after case creation */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.CASE_EVENTS.CASE_VIEW_OPENED_AFTER_CREATE, data);
};

export default {
  publishDisplayCreatedCaseToasterEvent,
  publishCreateStageDoneEvent,
  publishCaseViewOpenedAfterCreateEvent
};
